const smallColumbWidth = '240px';
const minSmallColumbWidth = '160px';
export const ProductListData = {
  productData: [
    {
      id: 'pl-1',
      image: 'product-table-1.png',
      title: 'Black Jacket',
      description: "Men's Black Jacket",
      amount: 100,
      stock: 10,
      start_date: '2022/02/25',
    },
    {
      id: 'pl-2',
      image: 'product-table-2.png',
      title: "Women's Shirt",
      description: "Women's Shirt Brown Shirt",
      amount: 235,
      stock: 0,
      start_date: '2022/08/25',
    },
    {
      id: 'pl-3',
      image: 'product-table-3.png',
      title: "Men's T-shirt",
      description: "Men's Blue T-shirt",
      amount: 10,
      stock: 0,
      start_date: '2022/03/12',
    },
    {
      id: 'pl-4',
      image: 'product-table-4.png',
      title: "Women's Dress",
      description: "Blue Women's Dress",
      amount: 65,
      stock: 0,
      start_date: '2022/08/23',
    },
    {
      id: 'pl-5',
      image: 'product-table-5.png',
      title: "Men's T-shirt",
      description: "Men's White T-shirt",
      amount: 85,
      stock: 0,
      start_date: '2022/09/13',
    },
    {
      id: 'pl-6',
      image: 'product-table-6.png',
      title: "Women's Jacket",
      description: "Women's Red Jacket",
      amount: 35,
      stock: 2,
      start_date: '2022/07/05',
    },
    {
      id: 'pl-7',
      image: 'product-table-1.png',
      title: 'Black Jacket',
      description: "Men's Black Jacket",
      amount: 95,
      stock: 10,
      start_date: '2022/02/25',
    },
    {
      id: 'pl-8',
      image: 'product-table-2.png',
      title: "Women's Shirt",
      description: "Women's Shirt Brown Shirt",
      amount: 100,
      stock: 0,
      start_date: '2022/08/25',
    },
    {
      id: 'pl-9',
      image: 'product-table-3.png',
      title: "Men's T-shirt",
      description: "Men's Blue T-shirt",
      amount: 120,
      stock: 0,
      start_date: '2022/03/12',
    },
    {
      id: 'pl-9',
      image: 'product-table-4.png',
      title: "Women's Dress",
      description: "Blue Women's Dress",
      amount: 125,
      stock: 0,
      start_date: '2022/08/23',
    },
    {
      id: 'pl-10',
      image: 'product-table-1.png',
      title: 'Black Jacket',
      description: "Men's Black Jacket",
      amount: 100,
      stock: 10,
      start_date: '2022/02/25',
    },
    {
      id: 'pl-11',
      image: 'product-table-2.png',
      title: "Women's Shirt",
      description: "Women's Shirt Brown Shirt",
      amount: 235,
      stock: 0,
      start_date: '2022/08/25',
    },
    {
      id: 'pl-12',
      image: 'product-table-3.png',
      title: "Men's T-shirt",
      description: "Men's Blue T-shirt",
      amount: 10,
      stock: 0,
      start_date: '2022/03/12',
    },
    {
      id: 'pl-13',
      image: 'product-table-4.png',
      title: "Women's Dress",
      description: "Blue Women's Dress",
      amount: 65,
      stock: 0,
      start_date: '2022/08/23',
    },
    {
      id: 'pl-14',
      image: 'product-table-5.png',
      title: "Men's T-shirt",
      description: "Men's White T-shirt",
      amount: 85,
      stock: 0,
      start_date: '2022/09/13',
    },
    {
      id: 'pl-15',
      image: 'product-table-6.png',
      title: "Women's Jacket",
      description: "Women's Red Jacket",
      amount: 35,
      stock: 2,
      start_date: '2022/07/05',
    },
    {
      id: 'pl-16',
      image: 'product-table-1.png',
      title: 'Black Jacket',
      description: "Men's Black Jacket",
      amount: 95,
      stock: 10,
      start_date: '2022/02/25',
    },
    {
      id: 'pl-17',
      image: 'product-table-2.png',
      title: "Women's Shirt",
      description: "Women's Shirt Brown Shirt",
      amount: 100,
      stock: 0,
      start_date: '2022/08/25',
    },
    {
      id: 'pl-18',
      image: 'product-table-3.png',
      title: "Men's T-shirt",
      description: "Men's Blue T-shirt",
      amount: 120,
      stock: 0,
      start_date: '2022/03/12',
    },
    {
      id: 'pl-19',
      image: 'product-table-4.png',
      title: "Women's Dress",
      description: "Blue Women's Dress",
      amount: 125,
      stock: 0,
      start_date: '2022/08/23',
    },
  ],
  productColumns: [
    {
      name: 'Image',
      selector: (row) => row.image,
      sortable: true,
      maxWidth: '130px',
    },
    {
      name: 'Details',
      selector: (row) => row.details,
      sortable: true,
      wrap: true,
      minWidth: '255px',
    },
    {
      name: 'Amount',
      selector: (row) => row.amount,
      sortable: true,
      maxWidth: smallColumbWidth,
      minWidth: minSmallColumbWidth,
    },
    {
      name: 'Stock',
      selector: (row) => row.stock,
      sortable: true,
      maxWidth: smallColumbWidth,
      minWidth: minSmallColumbWidth,
    },
    {
      name: 'Start date',
      selector: (row) => row.start_date,
      sortable: true,
      maxWidth: smallColumbWidth,
      minWidth: minSmallColumbWidth,
    },
    {
      name: 'Action',
      selector: (row) => row.action,
      sortable: true,
      maxWidth: smallColumbWidth,
      minWidth: minSmallColumbWidth,
    },
  ],
};
